export default __webpack_public_path__ + "static/plug_b.8c5071e4b4d07e97943cf76b5b3e335d.png";